import * as effects from 'redux-saga/effects';
import { IApplicationState } from '..';

import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import { isNullOrUndefined } from '../../Utils/Various';
import { initializeData } from '../Dashboard/Actions';
import { setExportFile } from '../Export/Actions';
import { resetFilters } from '../Search/Actions';
import { logout } from '../User/Actions';
import { IUserState } from '../User/Types';
import { IDashboardState } from '../Dashboard/Types';
import {
    buildElectionLegisCirTableColumns,
    buildElectionLegisNatTableColumns,
    buildElectionPresTableColumns,
    buildNationalTableColumns,
    buildRegionalTableColumns,
    getCircoList,
    getCircoListSuccess,
    getCircoVirtList,
    getCircoVirtListSuccess,
    getDashboardCirconscription,
    getDashboardCirconscriptionSuccess,
    getDashboardElection, getDashboardElectionDetail, getDashboardElectionDetailSuccess, getDashboardElectionSuccess,
    getDeclarationCSA,
    getDeclarationCSASuccess,
    getDetailEtudeIds,
    getDetailEtudeIdsSuccess,
    getStudyTypes, getStudyTypesSuccess, getTimeAllocation, getTimeAllocationLegislative, getTimeAllocationLegislativeCirSuccess, getTimeAllocationLegislativeNatSuccess, getTimeAllocationSuccess, getXlsDashboardCirconscription, getXlsDashboardCirconscriptionSuccess, getXlsDashboardElection, getXlsDashboardElectionDetail, getXlsDashboardElectionDetailSuccess, getXlsDashboardElectionSuccess, getXlsDashboardLegislativ, getXlsDashboardLegislativSuccess, getXlsDeclarationCSA, getXlsDeclarationCSASuccess, setElectionPage, setStudyType
} from './Actions';
import { getCurrentEtude } from './Reducer';
import { IElectionFilters, IElectionsActionTypes, IElectionsState, IElectionsStudyType } from './Types';

function* handleGetStudyTypes(action: ReturnType<typeof getStudyTypes>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getHomeStudyType, [action.payload as any]);
        if (!isNullOrUndefined(res)) {
            if (res.results && res.results.elections) {
                res.results.elections.sort((a: any, b: any) => {
                    return new Date(b.start).getTime() - new Date(a.start).getTime();
                });
            }
            yield effects.put(getStudyTypesSuccess(res.results))
            
            const dashboard: IDashboardState = yield effects.select((state: IApplicationState) => state.dashboard);
            let selectedElection: any = null;
            if (res.results && res.results.elections) {
                selectedElection = res.results.elections.find((x: any) => {
                    if (dashboard.dateCloture) {
                        return new Date(x.start) <= new Date(dashboard.dateCloture);
                    }
                    return true;
                });
                if (!selectedElection && res.results.elections.length > 0) {
                     selectedElection = res.results.elections[0];
                }
            }

            if (selectedElection) {
                const elections: IElectionsState = yield effects.select((state: IApplicationState) => state.elections);
                if (elections.isElectionChecked) {
                    // Correct elections_start_date to the valid (started) election.
                    // handleSetStudyType will also dispatch getDetailEtudeIds.
                    yield effects.put(setStudyType(selectedElection));
                } else {
                    yield effects.put(getDetailEtudeIds(selectedElection.id));
                }
                const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
                yield effects.put(getCircoList(selectedElection.id, false, user.allMediasID))
            }
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getStudyTypes');
    }
}
function* handleGetCircoList(action: ReturnType<typeof getCircoList>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getCircoList, action.payload as any);
        if (!isNullOrUndefined(res)) {
            if (res.status_code === 200) {

                yield effects.put(getCircoListSuccess(res.results))
            } else if (res.status_code === 400) {
                Logger.warn({}, res.results);
                yield effects.put(logout())
            }
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getCircoList');
    }
}
function* handleGetCircoVirtList(action: ReturnType<typeof getCircoVirtList>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getCircoList, [action.payload[0], action.payload[1]] as any);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getCircoVirtListSuccess(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getCircoVirtList');
    }
}
function* handleGetDashboardElection(action: ReturnType<typeof getDashboardElection>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getDashboardElection, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getDashboardElectionSuccess(res.results))
            yield effects.put(buildNationalTableColumns())
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getDashboardElection');
    }
}
function* handleGetTimeAllocationLegislative(action: ReturnType<typeof getTimeAllocationLegislative>): any {
    const backend = Backend.getInstance();
    let filters: IElectionFilters = action.payload;
    try {
        const res = yield effects.apply(backend, backend.getTimeAllocationLegislative, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
            if (filters.is_nat) {
                yield effects.put(buildElectionLegisNatTableColumns(res.results, user.permissions));
                yield effects.put(getTimeAllocationLegislativeNatSuccess(res.results, user.permissions));
            } else {
                yield effects.put(buildElectionLegisCirTableColumns(res.results, user.permissions));
                yield effects.put(getTimeAllocationLegislativeCirSuccess(res.results, user.permissions));
            }
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getTimeAllocationLegislative');
    }
}
function* handleGetDashboardCirconscription(action: ReturnType<typeof getDashboardCirconscription>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getDashboardCirconscription, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getDashboardCirconscriptionSuccess(res.results))
            yield effects.put(buildRegionalTableColumns())
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getDashboardCirconscription');
    }
}
function* handleGetXlsDashboardElectionDetail(action: ReturnType<typeof getXlsDashboardElectionDetail>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getXlsDashboardElectionDetail, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getXlsDashboardElectionDetailSuccess(res.results))
            yield effects.put(setExportFile(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getXlsDashboardElectionDetail');
    }
}
function* handleGetXlsDashboardElection(action: ReturnType<typeof getXlsDashboardElection>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getXlsDashboardElection, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getXlsDashboardElectionSuccess(res.results))
            yield effects.put(setExportFile(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getXlsDashboardElection');
    }
}
function* handleGetXlsDashboardCirconscription(action: ReturnType<typeof getXlsDashboardCirconscription>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getXlsDashboardCirconscription, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getXlsDashboardCirconscriptionSuccess(res.results))
            yield effects.put(setExportFile(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getXlsDashboardCirconscription');
    }
}
function* handleGetXlsDashboardLegislativ(action: ReturnType<typeof getXlsDashboardLegislativ>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getXlsDashboardLegislativ, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getXlsDashboardLegislativSuccess(res.results))
            yield effects.put(setExportFile(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getXlsDashboardCirconscription');
    }
}
function* handleGetXlsDeclarationCSA(action: ReturnType<typeof getXlsDeclarationCSA>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getXlsDeclarationCSA, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getXlsDeclarationCSASuccess(res.results))
            yield effects.put(setExportFile(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getXlsDeclarationCSA');
    }
}
function* handleGetDeclarationCSA(action: ReturnType<typeof getDeclarationCSA>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getDeclarationCSA, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getDeclarationCSASuccess(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getDeclarationCSA');
    }
}
function* handleGetDashboardElectionDetail(action: ReturnType<typeof getDashboardElectionDetail>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getDashboardElectionDetail, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            yield effects.put(getDashboardElectionDetailSuccess(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getDashboardElectionDetail');
    }
}
function* handleSetStudyType(action: ReturnType<typeof setStudyType>): any {
    if (action.payload) {
        yield effects.put(getDetailEtudeIds(action.payload.id))
    }
}
function* handleSetElectionPage(action: ReturnType<typeof setElectionPage>): any {

    try {
        const elections: IElectionsState = yield effects.select((state: IApplicationState) => state.elections);
        const dashboard: IDashboardState = yield effects.select((state: IApplicationState) => state.dashboard);

        let study_type: IElectionsStudyType = getCurrentEtude(elections.elections_study_types)
        
        if (elections.elections_study_types) {
            const validElection = elections.elections_study_types.find((x: any) => {
                if (dashboard.dateCloture) {
                    return new Date(x.start) <= new Date(dashboard.dateCloture);
                }
                return true;
            });
            if (validElection) {
                study_type = validElection;
            }
        }
        
        if (action.payload && study_type) {
            yield effects.put(resetFilters())
            yield effects.put(initializeData())
            yield effects.put(setStudyType(study_type))
        } else {
            yield effects.put(resetFilters())
            yield effects.put(initializeData())
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed setStudyType');
    }
}
function* handleGetTimeAllocation(action: ReturnType<typeof getTimeAllocation>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getTimeAllocation, [action.payload as any]);

        if (!isNullOrUndefined(res)) {
            const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
            yield effects.put(getTimeAllocationSuccess(res.results, user.permissions))
            yield effects.put(buildElectionPresTableColumns(res.results, user.permissions))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getTimeAllocation');
    }
}
function* handleGetDetailsEtudeIds(action: ReturnType<typeof getDetailEtudeIds>): any {
    const backend = Backend.getInstance();

    try {
        const res = yield effects.apply(backend, backend.getDetailEtudeIds, [action.payload as any]);
        if (!isNullOrUndefined(res)) {

            yield effects.put(getDetailEtudeIdsSuccess(res.results))
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getDetailEtudeIds');
    }
}
function* watchElections() {
    yield effects.takeEvery(IElectionsActionTypes.GET_STUDY_TYPES, handleGetStudyTypes);
    yield effects.takeEvery(IElectionsActionTypes.GET_CIRCO_LIST, handleGetCircoList);
    yield effects.takeEvery(IElectionsActionTypes.GET_CIRCO_VIRT_LIST, handleGetCircoVirtList);
    yield effects.takeEvery(IElectionsActionTypes.GET_DASHBOARD_ELECTION, handleGetDashboardElection);
    yield effects.takeEvery(IElectionsActionTypes.GET_DASHBOARD_CIRCONSCRIPTION, handleGetDashboardCirconscription);
    yield effects.takeEvery(IElectionsActionTypes.GET_XLS_DASHBOARD_ELECTION_DETAIL, handleGetXlsDashboardElectionDetail);
    yield effects.takeEvery(IElectionsActionTypes.GET_XLS_DASHBOARD_ELECTION, handleGetXlsDashboardElection);
    yield effects.takeEvery(IElectionsActionTypes.GET_XLS_DASHBOARD_LEGISLATIV, handleGetXlsDashboardLegislativ);
    yield effects.takeEvery(IElectionsActionTypes.GET_XLS_DASHBOARD_CIRCONSCRIPTION, handleGetXlsDashboardCirconscription);
    yield effects.takeEvery(IElectionsActionTypes.GET_XLS_DECLARATION_CSA, handleGetXlsDeclarationCSA);
    yield effects.takeEvery(IElectionsActionTypes.GET_DASHBOARD_ELECTION_DETAIL, handleGetDashboardElectionDetail);
    yield effects.takeEvery(IElectionsActionTypes.GET_DECLARATION_CSA, handleGetDeclarationCSA);
    yield effects.takeEvery(IElectionsActionTypes.SET_ELECTION_PAGE, handleSetElectionPage);
    yield effects.takeEvery(IElectionsActionTypes.GET_TIME_ALLLOCATION, handleGetTimeAllocation);
    yield effects.takeEvery(IElectionsActionTypes.GET_TIME_ALLLOCATION_LEGISLATIVE, handleGetTimeAllocationLegislative);
    yield effects.takeEvery(IElectionsActionTypes.GET_DETAIL_ETUDE_IDS, handleGetDetailsEtudeIds);
    yield effects.takeEvery(IElectionsActionTypes.SET_STUDY_TYPE, handleSetStudyType);
}

export function* ElectionsSaga() {
    yield effects.all([
        effects.fork(watchElections),
    ]);
}
